import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Route } from "react-router-dom";
import { push } from "react-router-redux";
import { Grid, Ref } from "semantic-ui-react";
import cx from "classnames";
import qs from "qs";
import {
  Carousel,
  RoomBox,
  RateDetails,
  RoomsResultsGroup,
  VirtualAnalyticsAppender
} from "../../components";
import {
  Amenities,
  Header,
  AnimatedSwitch,
  PlaceHolder
} from "../../components/common";
import * as roomResultsActions from "../../actions/roomResultsActions";
import * as addonsActions from "../../actions/addonsActions";
import * as paxActions from "../../actions/paxActions";
import * as ratesActions from "../../actions/ratesActions";
import * as discountClubActions from "../../actions/discountClubActions";
import { setThumbnailDisplay } from "../../actions/thumbnailDisplayActions";
import {
  getAnalyticsPlaceHolders,
  clearAnalyticsPlaceHolders
} from "../../actions/placeHoldersActions";
import {
  isRTL,
  getRoomToDisplay,
  getRoomsPerPax,
  getCurrentPaxCombination,
  getSelectedRoomId,
  getSelectedHotelName
} from "../../reducers";
import {
  HOTEL_RESULTS_ANALYTICS_PHASE,
  ROOM_RESULTS_ANALYTICS_PHASE
} from "../../constants/general";
import {
  getPropertyItemTitle,
  getPropertyWhichTitle
} from "../../helpers/general-helpers";
import { noop } from "../../helpers/functional";
import { isElementInViewPort } from "../../helpers/domHelpers";
import styles from "./styles.less";
import ThumbNailCustom from "../../components/ThumbNailCustom/ThumbNailCustom";

class SearchResults extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ratesGroupVisible: false,
      appearRates: true
    };
  }

  componentDidMount() {
    this.loadData();
  }

  async componentDidUpdate(prevProps) {
    const {
      searchDataTimestamp,
      roomsPerPax
      //displayRoomId,
      //selectedHotelId
    } = this.props;
    if (
      searchDataTimestamp &&
      searchDataTimestamp > prevProps.searchDataTimestamp
    ) {
      await this.loadData();
    }
    if (roomsPerPax != prevProps.roomsPerPax && !prevProps.roomsPerPax) {
      this.setDispalyFormat();
    }
  }

  // on unmount of the SearchResults comp - leave hotel group.
  // this one is useful when navigate between app view so there is no connection disconnection.
  componentWillUnmount() {
    // reset all user selection in store so the next SearchResults mounting will be with no selections..
    //todo check if this effects back process
    //this.resetData();

    try {
      window._hub.invoke("leaveGroup");
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log("signalR leaveGroup invoke failed", error);
    }
  }

  /**
   * Get analytics code from server and append it to #page-analytics-wrapper element ( append action include the execution ).
   * Generate the code with the data stored until this phase ( ex, no masterid )
   */
  getAnalyticsPlaceHolders = (phase, data) => {
    const {
      selectedHotelId,
      hotelName,
      checkinDate,
      checkoutDate,
      promoCode,
      actions
    } = this.props;
    const postObject = {
      Phase: phase,
      HotelId: selectedHotelId,
      HotelName: hotelName,
      CheckInDate: checkinDate,
      CheckoutDate: checkoutDate,
      PromoCode: promoCode,
      ...data
    };
    actions.getAnalyticsPlaceHolders(postObject);
  };

  getHotelAnalyticsPlaceHolders = () => {
    this.getAnalyticsPlaceHolders(HOTEL_RESULTS_ANALYTICS_PHASE);
  };

  getRoomAnalyticsPlaceHolders = () => {
    const { displayRoomId } = this.props;
    this.getAnalyticsPlaceHolders(ROOM_RESULTS_ANALYTICS_PHASE, {
      RoomId: displayRoomId
    });
  };

  setDispalyFormat = () => {
    const {
      roomsPerPax,
      selectedPaxId,
      thumbanilDisplay,
      allwayShowInRoomUnderRoomDisplay,
      showThumbnailDisplay,
      numRoomsToSwitchToThumnailDisplay,
      actions
    } = this.props;
    const shouldDisplayThubmnail =
      selectedPaxId > 0
        ? thumbanilDisplay
        : allwayShowInRoomUnderRoomDisplay >= roomsPerPax.length
          ? false
          : showThumbnailDisplay ||
            (roomsPerPax &&
              numRoomsToSwitchToThumnailDisplay <= roomsPerPax.length);

    if (selectedPaxId == 0) {
      actions.setThumbnailDisplay(
        shouldDisplayThubmnail ? shouldDisplayThubmnail : false
      );
    }
  };

  resetData = () => {
    this.props.actions.resetSelection();
    this.props.actions.resetRoomResult();
  };

  async loadData() {
    const {
      selectedHotelId: hotelId,
      checkinDate: fromDate,
      checkoutDate: toDate,
      lang,
      promoCode,
      paxList,
      selectedRoomCategory,
      chainHotels,
      isDealMode,
      actions,
      onLoad,
      onDataLoaded
    } = this.props;
    onLoad();
    const reqPaxList =
      paxList &&
      paxList.map(pax => {
        return {
          ...pax,
          rateId: null,
          roomId: null
        };
      });

    const reqObj = {
      hotelId,
      fromDate,
      toDate,
      promoCode,
      pax: reqPaxList,
      roomCategory: selectedRoomCategory,
      lang
    };
    if (!isDealMode) {
      await actions.getRoomResults(reqObj); // pause next execution
    }
    await actions.getAddonsResult(reqObj); // pause next execution
    const { sortRatesByDefault } = this.props; // we waited for the result, the props have changed.
    if (sortRatesByDefault) {
      actions.sortRatesByLowestPrice();
    }
    // if chain includes more than 1 hotel
    // then set title to the search results page as current selected hotel name
    if (chainHotels.length > 1) {
      const selectedHotel = chainHotels.find(h => h.id === parseInt(hotelId));
      this.setState(() => ({ title: selectedHotel && selectedHotel.name }));
    }
    onDataLoaded();
  }

  onClubPricesInterestingClick = () => {
    const { isClubPricesInterested } = this.props;
    this.props.actions.setClubPricesInteresting(!isClubPricesInterested);
  };

  onRoomClick = roomId => {
    const { actions, routing } = this.props;
    const getRoomRouteWithQuery = () => {
      const currentQuery = qs.parse(routing.location.search, {
        ignoreQueryPrefix: true
      });
      return {
        pathname: "/hotel/room",
        search: qs.stringify(currentQuery, {
          addQueryPrefix: true,
          encode: false
        }),
        notifyRoute: this.props.notifyRouteChange
      };
    };
    actions.changeDisplayRoom(roomId);
    actions.push(getRoomRouteWithQuery(roomId));
  };

  setRouteTohotel = () => {
    const { actions, routing } = this.props;
    const setHotelRoute = () => {
      const currentQuery = qs.parse(routing.location.search, {
        ignoreQueryPrefix: true
      });
      return {
        pathname: "/hotel",
        search: qs.stringify(currentQuery, {
          addQueryPrefix: true,
          encode: false
        }),
        notifyRoute: this.props.notifyRouteChange
      };
    };
    actions.push(setHotelRoute());
  };

  onRateSelection = ({ ...selectedRateParams }) => {
    const { onRateSelection } = this.props;

    // dispatch global event of roomselected
    const event = new CustomEvent("__be_roomSelected", {
      detail: {
        roomId: selectedRateParams.roomId
      }
    });
    window.dispatchEvent(event);

    onRateSelection({
      ...selectedRateParams
    });
  };

  onShowRoomDetailsClick = roomId => {
    const { onShowRoomDetailsClick } = this.props;
    onShowRoomDetailsClick(roomId);
  };

  onRateReadMore = (rateId, roomId) => {
    const { onRateReadMore } = this.props;
    onRateReadMore({ rateId, roomId, render: this.renderRateDetails });
  };

  onShowMoreAmenities = roomId => {
    const { onShowMoreAmenities } = this.props;
    onShowMoreAmenities({ roomId, render: this.renderAllAmenities });
  };

  showSimpleClubLoginModal = () => {
    const { showSimpleClubLoginModal } = this.props;
    showSimpleClubLoginModal();
  };

  handleSearchresultsRef = node => {
    const { handleSearchresultsRef } = this.props;
    if (handleSearchresultsRef) {
      handleSearchresultsRef(node);
    }
  };

  handleCarouselRef = node => {
    const { handleCarouselRef } = this.props;
    if (handleCarouselRef) {
      handleCarouselRef(node);
    } else {
      this.carousel = node;
    }
  };

  handleRoomboxRef = node => {
    const { handleRoomboxRef } = this.props;
    if (handleRoomboxRef) {
      handleRoomboxRef(node);
    } else {
      this.roombox = node;
    }
  };

  handleRatesGroupRef = node => {
    const { handleRatesGroupRef } = this.props;
    const ratesGroupVisible = isElementInViewPort(node);
    this.setState({ ratesGroupVisible });
    if (handleRatesGroupRef) {
      handleRatesGroupRef(node);
    } else {
      this.ratesGroup = node;
    }
  };

  handleContactUsFormRef = node => {
    const { handleContactUsFormRef } = this.props;
    if (handleContactUsFormRef) {
      handleContactUsFormRef(node);
    } else {
      this.contactUsForm = node;
    }
  };

  handleRoomBoxHeaderRef = node => {
    const { handleRoomBoxHeaderRef } = this.props;
    if (handleRoomBoxHeaderRef) {
      handleRoomBoxHeaderRef(node);
    } else {
      this.roomBoxHeader = node;
    }
  };

  sortRoomsBySortOrder = () => {
    const { roomsPerPax } = this.props;
    const copiedArray = [...roomsPerPax]; // not mutating the array (sort is mutating)
    const sortedRooms = copiedArray.sort((a, b) => {
      const { sortOrder: sortOrderA } = a;
      const { sortOrder: sortOrderB } = b;
      if (sortOrderA < sortOrderB) {
        return -1;
      } else if (sortOrderA > sortOrderB) {
        return 1;
      } else {
        return 0;
      }
    });
    return sortedRooms;
  };

  renderRateDetails = rate => {
    const { titles, isRtl, ShowCancellationPolicy, isMobileView } = this.props;
    return (
      <RateDetails
        {...rate}
        titles={titles}
        isRtl={isRtl}
        ShowCancellationPolicy={ShowCancellationPolicy}
        isMobileView={isMobileView}
      />
    );
  };

  renderAllAmenities = amenities => {
    const { isRtl, isMobileView } = this.props;
    return (
      <Amenities
        amenities={amenities}
        isRtl={isRtl}
        includeName={true}
        isntPreview={true}
        isMobileView={isMobileView}
      />
    );
  };

  getEffectiveRoomId = () => {
    const { selectedRoomId, selectedRoomToDisplay } = this.props;
    const effectiveSelectedRoomId =
      selectedRoomId || (selectedRoomToDisplay && selectedRoomToDisplay.id);
    return effectiveSelectedRoomId;
  };

  renderRoomsResults = () => {
    const {
      isIE,
      selectedPaxId,
      isRtl,
      lang,
      checkinDate,
      checkoutDate,
      selectedOption,
      titles,
      isMobileView,
      hotelData,
      showAvailability,
      lowAvailabilityCount,
      currentPaxCombination,
      discountClubConfig,
      clubUserLoggedIn,
      isClubPricesInterested,
      showSimpleClubLoginModal,
      onShowRatesClick,
      onShowContactUsForm,
      contactUsSubmitingStatus,
      submitContactUsForm,
      onLoad,
      ShowCancellationPolicy,
      onShowRoomGalleryPopUp,
      isIos,
      isDealMode,
      placeHolders,
      actions
    } = this.props;
    const selectedRateIdOfCurrentPax =
      currentPaxCombination && currentPaxCombination.rateId; //check if correct , allways returns undefined
    const sortedRooms = this.sortRoomsBySortOrder();
    const { ratesGroupVisible } = this.state;
    return (
      <Grid>
        <Grid.Row>
          <Grid.Column width={16}>{this.renderSelectRoomTitle()}</Grid.Column>
        </Grid.Row>
        <PlaceHolder
          placeHolders={placeHolders}
          component={"SearchResults"}
          location={"HeaderBottom"}
        />{" "}
        <VirtualAnalyticsAppender
          getAnalyticsPlaceHolders={this.getHotelAnalyticsPlaceHolders}
          clearAnalyticsPlaceHolders={actions.clearAnalyticsPlaceHolders}
        />
        {sortedRooms.map(room => (
          <Grid.Column
            width={16}
            className={styles.roomDataRatesWrapper}
            key={room.id + selectedPaxId}
          >
            <Grid>
              <Grid.Row
                columns={1}
                className={isMobileView ? "" : styles.compactTop}
              >
                <Ref innerRef={this.handleRoomboxRef}>
                  <RoomBox
                    isRtl={isRtl}
                    lang={lang}
                    titles={titles}
                    hotelData={hotelData}
                    checkinDate={checkinDate}
                    checkoutDate={checkoutDate}
                    selectedOption={selectedOption}
                    contactUsSubmitingStatus={contactUsSubmitingStatus}
                    submitContactUsForm={submitContactUsForm}
                    room={room}
                    currentPaxCombination={currentPaxCombination}
                    defaultImage={room && room.DefaultImageUrl}
                    selectedRateIdOfCurrentPax={selectedRateIdOfCurrentPax}
                    clubUserLoggedIn={clubUserLoggedIn}
                    isClubActive={
                      discountClubConfig && discountClubConfig.Active
                    }
                    clubPercentageDiscount={
                      discountClubConfig && discountClubConfig.Percentage
                    }
                    isClubPricesInterested={isClubPricesInterested}
                    ratesGroupRef={this.handleRatesGroupRef}
                    contactUsFormRef={this.handleContactUsFormRef}
                    roomBoxDetailsHeaderRef={this.handleRoomBoxHeaderRef}
                    scrollToRatesRef={this.ratesGroup}
                    showFullHeaderDetails={true}
                    showAvailability={showAvailability}
                    lowAvailabilityCount={lowAvailabilityCount}
                    showSimpleClubLoginModal={showSimpleClubLoginModal}
                    onRateSelection={this.onRateSelection}
                    onRateReadMore={this.onRateReadMore}
                    onShowContactUsForm={onShowContactUsForm}
                    onShowMoreAmenities={this.onShowMoreAmenities}
                    onRoomDetailsClick={this.onShowRoomDetailsClick}
                    onClubPricesInterestingClick={
                      this.onClubPricesInterestingClick
                    }
                    onShowRatesClick={onShowRatesClick}
                    isMobileView={isMobileView}
                    onLoad={onLoad}
                    ShowCancellationPolicy={ShowCancellationPolicy}
                    isDealMode={isDealMode}
                    isIE={isIE}
                    isIos={isIos}
                    ratesGroupVisible={ratesGroupVisible}
                    onShowRoomGalleryPopUp={onShowRoomGalleryPopUp}
                    switchImagesAutomatically={false}
                    selectedPaxId={selectedPaxId}
                  />
                </Ref>
              </Grid.Row>
            </Grid>
            <hr className={styles.roomSeperator} />
          </Grid.Column>
        ))}
      </Grid>
    );
  };

  renderRoomData = () => {
    const {
      isIE,
      isRtl,
      lang,
      checkinDate,
      checkoutDate,
      selectedOption,
      titles,
      isMobileView,
      hotelData,
      selectedRoomToDisplay,
      showAvailability,
      lowAvailabilityCount,
      currentPaxCombination,
      discountClubConfig,
      clubUserLoggedIn,
      isClubPricesInterested,
      showSimpleClubLoginModal,
      onShowRatesClick,
      onShowContactUsForm,
      contactUsSubmitingStatus,
      submitContactUsForm,
      onLoad,
      ShowCancellationPolicy,
      onShowRoomGalleryPopUp,
      selectedPaxId,
      paxList,
      isIos,
      isDealMode,
      placeHolders,
      actions
    } = this.props;
    const selectedRateIdOfCurrentPax =
      currentPaxCombination && currentPaxCombination.rateId; //check if correct , allways returns undefined
    //const hasResults = roomsPerPax && roomsPerPax.length > 0;
    const shouldRenderThumbnails = false;
    //hasResults && roomsPerPax.length > 1 && !isMobileView;
    const sortedRooms = this.sortRoomsBySortOrder();
    const effectiveSelectedRoomId = this.getEffectiveRoomId();
    const { ratesGroupVisible } = this.state;
    const roomTitle =
      paxList.length > 1
        ? `${titles.ChooseRoom} ${selectedPaxId + 1} - ${
            titles.WhatPriceWouldYouChoose
          }`
        : titles.WhatPriceWouldYouChoose;

    return (
      <Grid.Column width={16}>
        <Grid>
          {shouldRenderThumbnails && (
            <Grid.Row columns={1} className={styles.compactBottom}>
              <Grid.Column>
                <Ref innerRef={this.handleCarouselRef}>
                  <Carousel
                    isRtl={isRtl}
                    titles={titles}
                    items={sortedRooms}
                    selectedItem={effectiveSelectedRoomId}
                    onItemClick={this.onRoomClick}
                    dots={false}
                    infinite={true}
                    showClubPrices={clubUserLoggedIn || isClubPricesInterested}
                    isIE={isIE}
                    isIos={isIos}
                  />
                </Ref>
              </Grid.Column>
            </Grid.Row>
          )}

          <Grid.Row>
            <Grid.Column width={16}>
              <Header
                text={roomTitle}
                isRtl={isRtl}
                isMobileView={isMobileView}
              />
            </Grid.Column>
          </Grid.Row>
          <PlaceHolder
            placeHolders={placeHolders}
            component={"RoomData"}
            location={"HeaderBottom"}
          />
          <Grid.Row
            columns={1}
            className={isMobileView ? "" : styles.compactTop}
          >
            <Ref innerRef={this.handleRoomboxRef}>
              <RoomBox
                isRtl={isRtl}
                lang={lang}
                titles={titles}
                hotelData={hotelData}
                checkinDate={checkinDate}
                checkoutDate={checkoutDate}
                selectedOption={selectedOption}
                contactUsSubmitingStatus={contactUsSubmitingStatus}
                submitContactUsForm={submitContactUsForm}
                room={selectedRoomToDisplay}
                currentPaxCombination={currentPaxCombination}
                defaultImage={
                  selectedRoomToDisplay && selectedRoomToDisplay.DefaultImageUrl
                }
                selectedRateIdOfCurrentPax={selectedRateIdOfCurrentPax}
                clubUserLoggedIn={clubUserLoggedIn}
                isClubActive={discountClubConfig && discountClubConfig.Active}
                clubPercentageDiscount={
                  discountClubConfig && discountClubConfig.Percentage
                }
                isClubPricesInterested={isClubPricesInterested}
                ratesGroupRef={this.handleRatesGroupRef}
                contactUsFormRef={this.handleContactUsFormRef}
                roomBoxDetailsHeaderRef={this.handleRoomBoxHeaderRef}
                scrollToRatesRef={this.ratesGroup}
                showFullHeaderDetails={true}
                showAvailability={showAvailability}
                lowAvailabilityCount={lowAvailabilityCount}
                showSimpleClubLoginModal={showSimpleClubLoginModal}
                onRateSelection={this.onRateSelection}
                onRateReadMore={this.onRateReadMore}
                onShowContactUsForm={onShowContactUsForm}
                onShowMoreAmenities={this.onShowMoreAmenities}
                onRoomDetailsClick={this.onShowRoomDetailsClick}
                onClubPricesInterestingClick={this.onClubPricesInterestingClick}
                onShowRatesClick={onShowRatesClick}
                isMobileView={isMobileView}
                onLoad={onLoad}
                ShowCancellationPolicy={ShowCancellationPolicy}
                isDealMode={isDealMode}
                isIE={isIE}
                isIos={isIos}
                ratesGroupVisible={ratesGroupVisible}
                onShowRoomGalleryPopUp={onShowRoomGalleryPopUp}
                getAnalyticsPlaceHolders={this.getRoomAnalyticsPlaceHolders}
                clearAnalyticsPlaceHolders={actions.clearAnalyticsPlaceHolders}
              />
            </Ref>
          </Grid.Row>
        </Grid>
      </Grid.Column>
    );
  };

  renderSelectRoomTitle = () => {
    const {
      titles,
      paxList,
      selectedPaxId,
      isRtl,
      isMobileView,
      propertyType
    } = this.props;
    const itemType = getPropertyItemTitle(titles, propertyType);
    const which = getPropertyWhichTitle(titles, propertyType);
    let headerText =
      paxList.length > 1
        ? `${titles.PleaseSelect} ${itemType} ${titles.Number} ${selectedPaxId +
            1} :`
        : `${which} ${itemType} ${titles.DoYouWantToSatyIn} `;
    return (
      <Header text={headerText} isRtl={isRtl} isMobileView={isMobileView} />
    );
  };

  renderRoomBoxMarkUp = product => {
    const {
      titles,
      isIE,
      discountClubConfig,
      clubUserLoggedIn,
      onShowRatesClick,
      isMobileView
    } = this.props;
    return (
      <ThumbNailCustom
        titles={titles}
        isIE={isIE}
        showClubPrices={
          discountClubConfig && discountClubConfig.Active && !clubUserLoggedIn
        }
        onClick={onShowRatesClick}
        product={product}
        isMobileView={isMobileView}
      />
    );
  };

  renderThumbnailResults = () => {
    const {
      titles,
      isRtl,
      isMobileView,
      onLoad,
      isIos,
      placeHolders,
      actions
    } = this.props;
    //const hasResults = roomsPerPax && roomsPerPax.length > 0;
    const sortedRooms = this.sortRoomsBySortOrder();
    return (
      <div className={styles.mobileViewWrapper}>
        <Grid.Row>
          <Grid.Column width={16}>{this.renderSelectRoomTitle()}</Grid.Column>
        </Grid.Row>
        <PlaceHolder
          placeHolders={placeHolders}
          component={"SearchResults"}
          location={"HeaderBottom"}
        />
        <Grid.Row columns={1}>
          <Grid.Column>
            <RoomsResultsGroup
              isMobileView={isMobileView}
              titles={titles}
              isRtl={isRtl}
              onShowRoomDetailsClick={this.onShowRoomDetailsClick}
              onRoomResultClick={this.onRoomClick}
              renderMarkup={this.renderRoomBoxMarkUp}
              results={sortedRooms}
              onLoad={onLoad}
              isIos={isIos}
              getAnalyticsPlaceHolders={this.getHotelAnalyticsPlaceHolders}
              clearAnalyticsPlaceHolders={actions.clearAnalyticsPlaceHolders}
            />
          </Grid.Column>
        </Grid.Row>
      </div>
    );
  };

  renderRoomsReusltRouting = () => {
    const { thumbanilDisplay, routing, roomsPerPax } = this.props;

    return (
      <AnimatedSwitch
        location={routing.location}
        timeout={450}
        className="switch-wrapper"
      >
        <Route path="/hotel/room" render={this.renderRoomData} />
        <Route
          path="/hotel"
          render={
            thumbanilDisplay && roomsPerPax.length > 1
              ? this.renderThumbnailResults
              : this.renderRoomsResults
          }
        />
      </AnimatedSwitch>
    );
  };

  toggleSbox = () => {
    this.setState(({ showSbox }) => ({ showSbox: !showSbox }));
  };

  setHotel = ({ target }) => {
    this.setState({ hotel: target.value });
  };

  setLang = ({ target }) => {
    this.setState({ lang: target.value });
  };

  render() {
    const {
      isfetchingRooms,
      renderLoader,
      roomsPerPax,
      isMobileView
    } = this.props;
    const hasResults = roomsPerPax && roomsPerPax.length > 0;
    return (
      <div className={styles.searchResults} ref={this.handleSearchresultsRef}>
        <Grid
          className={cx(styles.innerGrid, {
            [styles.mobileView]: isMobileView
          })}
          stretched
        >
          {isfetchingRooms || !hasResults
            ? renderLoader(isfetchingRooms)
            : this.renderRoomsReusltRouting()}
        </Grid>
      </div>
    );
  }
}

SearchResults.defaultProp = {
  onShowRoomDetailsClick: noop,
  onRateSelection: noop,
  onRateReadMore: noop,
  showSimpleClubLoginModal: noop,
  onDataLoaded: noop,
  handleCarouselRef: noop,
  handleRoomboxRef: noop,
  handleRatesGroupRef: noop,
  handleContactUsFormRef: noop,
  handleRoomBoxHeaderRef: noop,
  handleSearchresultsRef: noop,
  onShowRatesClick: noop,
  renderLoader: noop,
  onLoad: noop
};

SearchResults.propTypes = {
  isIE: PropTypes.bool,
  lang: PropTypes.string,
  promoCode: PropTypes.string,
  titles: PropTypes.object,
  routing: PropTypes.object,
  hotelData: PropTypes.object,
  hotelName: PropTypes.string,
  chainHotels: PropTypes.array,
  checkinDate: PropTypes.string,
  checkoutDate: PropTypes.string,
  selectedOption: PropTypes.object,
  paxList: PropTypes.array,
  showAvailability: PropTypes.bool,
  lowAvailabilityCount: PropTypes.number,
  viewDirection: PropTypes.string,
  isMobileView: PropTypes.bool,
  isRtl: PropTypes.bool,
  roomsPerPax: PropTypes.array,
  currentPaxCombination: PropTypes.object,
  selectedRoomToDisplay: PropTypes.object,
  selectedRoomId: PropTypes.string,
  rooms: PropTypes.object,
  actions: PropTypes.object,
  selectedPaxId: PropTypes.number,
  selectedHotelId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  displayRoomId: PropTypes.string,
  isfetchingRooms: PropTypes.bool,
  discountClubConfig: PropTypes.object,
  clubUserLoggedIn: PropTypes.bool,
  isClubPricesInterested: PropTypes.bool,
  onShowRoomDetailsClick: PropTypes.func,
  onRateSelection: PropTypes.func,
  onRateReadMore: PropTypes.func,
  onShowMoreAmenities: PropTypes.func,
  showSimpleClubLoginModal: PropTypes.func,
  onDataLoaded: PropTypes.func,
  handleCarouselRef: PropTypes.func,
  handleRoomboxRef: PropTypes.func,
  handleRatesGroupRef: PropTypes.func,
  handleContactUsFormRef: PropTypes.func,
  handleRoomBoxHeaderRef: PropTypes.func,
  handleSearchresultsRef: PropTypes.func,
  onShowRatesClick: PropTypes.func,
  onShowContactUsForm: PropTypes.func,
  renderLoader: PropTypes.func,
  onLoad: PropTypes.func,
  ShowCancellationPolicy: PropTypes.bool,
  searchDataTimestamp: PropTypes.number,
  contactUsSubmitingStatus: PropTypes.object,
  submitContactUsForm: PropTypes.func,
  resetContactUsStatus: PropTypes.func,
  notifyRouteChange: PropTypes.func,
  isDealMode: PropTypes.bool,
  dealSearchPerformed: PropTypes.bool,
  isIos: PropTypes.bool,
  onShowRoomGalleryPopUp: PropTypes.func,
  showThumbnailDisplay: PropTypes.bool,
  numRoomsToSwitchToThumnailDisplay: PropTypes.number,
  allwayShowInRoomUnderRoomDisplay: PropTypes.number,
  thumbanilDisplay: PropTypes.bool,
  placeHolders: PropTypes.array,
  propertyType: PropTypes.string
};

function mapStateToProps(store) {
  const hotelName = store.selectedHotelId && getSelectedHotelName(store);
  const state = {
    isIE: store.isIE,
    lang: store.lang,
    promoCode: store.promoCode,
    checkinDate: store.checkinDate,
    checkoutDate: store.checkoutDate,
    selectedOption: store.selectedOption,
    titles: store.titles,
    routing: store.routing,
    hotelData: store.hotelData,
    hotelName: hotelName,
    chainHotels: store.chainHotels,
    viewDirection: store.viewDirection,
    isMobileView: store.isMobileView,
    isRtl: isRTL(store),
    clubUserLoggedIn: store.clubUserLoggedIn,
    discountClubConfig: store.discountClubConfig,
    isClubPricesInterested: store.clubPricesInteresting,
    roomsPerPax: getRoomsPerPax(store),
    sortRatesByDefault: store.sortRatesByDefault,
    currentPaxCombination: getCurrentPaxCombination(store),
    selectedHotelId: store.selectedHotelId,
    paxList: store.paxList,
    showAvailability: store.showAvailability,
    lowAvailabilityCount: store.lowAvailabilityCount,
    rooms: store.rooms,
    selectedRoomToDisplay: getRoomToDisplay(store),
    selectedRoomId: getSelectedRoomId(store),
    selectedAddonsGroup: store.selectedAddonsGroup,
    displayRoomId: store.displayRoomId,
    selectedPaxId: store.selectedPaxId,
    isfetchingRooms: store.isfetchingRooms,
    ShowCancellationPolicy: store.ShowCancellationPolicy,
    searchDataTimestamp: store.searchDataTimestamp,
    isDealMode: store.isDealMode,
    isIos: store.isIos,
    selectedRoomCategory: store.selectedRoomCategory,
    contactUsSubmitingStatus: store.contactUsSubmitingStatus,
    showThumbnailDisplay: store.showThumbnailDisplay,
    numRoomsToSwitchToThumnailDisplay: store.numRoomsToSwitchToThumnailDisplay,
    allwayShowInRoomUnderRoomDisplay: store.allwayShowInRoomUnderRoomDisplay,
    thumbanilDisplay: store.thumbanilDisplay,
    placeHolders: store.placeHolders,
    propertyType: store.propertyType
  };
  return state;
}

function mapDispatchToProps(dispatch) {
  const combinedActions = {
    ...roomResultsActions,
    ...addonsActions,
    ...paxActions,
    ...ratesActions,
    ...discountClubActions,
    getAnalyticsPlaceHolders,
    clearAnalyticsPlaceHolders,
    setThumbnailDisplay,
    push
  };
  return {
    actions: bindActionCreators(combinedActions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SearchResults);



// WEBPACK FOOTER //
// ./src/containers/SearchResults/SearchResults.js